import { render, staticRenderFns } from "./SalesInvestArray.vue?vue&type=template&id=22285c4e&"
import script from "./SalesInvestArray.vue?vue&type=script&lang=js&"
export * from "./SalesInvestArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports